import React from "react";
import Footer from "./../Footer";
import { Link, withRouter } from "react-router-dom";

import { Pages, Settings } from "./Pages";

class Chapter4 extends React.Component {
  constructor(props) {
    super(props);

    this.page = Pages[5];
    this.handleTogglePopout = this.handleTogglePopout.bind(this);

    this.handlePopoutImages = this.handlePopoutImages.bind(this);
    this.popImages = [
      `${process.env.PUBLIC_URL}/images/liberty-bonds-1-lg.jpg`,
      `${process.env.PUBLIC_URL}/images/liberty-bonds-2-lg.jpg`,
      `${process.env.PUBLIC_URL}/images/charter-hearing.jpg`,
      `${process.env.PUBLIC_URL}/images/bank-assets.jpg`
    ];
  }

  handlePopoutImages = e => {
    this.props.popoutImages(e);
  };

  handleTogglePopout = popout => {
    this.props.togglePopout(popout);
  };

  componentDidMount() {
    this.props.bgHoverState(this.page.color);
    this.props.imageObjects(document.querySelectorAll(Settings.imageSelectors));

    this.props.gatherImages(this.popImages);

    document.title = `${this.page.name.replace(
      "<br />",
      ""
    )} | Peapack 100 Anniversary`;
    document.body.className = "page-inner page-chapter-4";
  }

  render() {
    return (
      <div className="page-wrapper">
        <div className="page">
          <div className="header-section wrapper">
            <div className="row">
              <div className="col-left col-md-6">
                <div className="header-content">
                  <Link
                    to="/"
                    onClick={this.props.bgHoverState}
                    className="back-button"
                  >
                    Back
                  </Link>
                  <h1 dangerouslySetInnerHTML={{ __html: this.page.name }} />
                  <div className="caption">
                    State of New Jersey Notice to appear for a Charter hearing
                    on January 12, 1932 (Peapack-Gladstone Bank archives)
                  </div>
                </div>
              </div>
              <div className="col-right col-md-6">
                <figure className="header-thumbnail anim-up">
                  <img
                    src={`${process.env.PUBLIC_URL}/images/peservering.jpg`}
                    alt=""
                  />
                </figure>
              </div>
            </div>
          </div>
          <div className="white-background entry-content">
            <div className="wrapper">
              <div className="row">
                <div className="col-lg-6 col-md-8">
                  <p>
                    During the Great Depression, jobs were scarce, and Americans
                    struggled to meet their financial obligations. Government
                    programs such as Social Security and Medicare did not yet
                    exist. As a result, many customers petitioned the Bank for
                    monthly payment relief until they were back on their feet.
                    Appeals made by desperate customers—often the Directors’
                    friends and neighbors—were taken to heart.
                  </p>
                  <p>
                    One such petitioner was a laborer named Atkinson M. “John”
                    Evans. He penciled his request to Bank executive Alvah
                    Alpaugh for temporary relief from a loan obligation in
                    January 1931, when he fell ill and was unable to work.
                  </p>
                  <p>
                    Another customer, Briant Philhower, was unable to find work
                    as a house painter. He paid what he could, relying on the
                    Bank’s compassion.
                  </p>
                  <p>
                    According to Bank records, no customer was foreclosed on
                    during the Great Depression. Customers were granted
                    extensions on payments, and local organizations—such as the
                    American Legion Post’s baseball team and the Sisters of St.
                    John the Baptist—continued to receive small donations of
                    support.
                  </p>
                </div>
                <div className="col-lg-6 col-md-4">
                  <figure className="img">
                    <div className="row row7">
                      <div className="col-lg-6 col-md-12 col-sm-6 mb-lg-0 mb-2">
                        <div
                          className="popout-image"
                          onClick={this.handlePopoutImages}
                        >
                          <img
                            src={`${process.env.PUBLIC_URL}/images/liberty-bonds-1-lg.jpg`}
                            alt=""
                          />
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-12 col-sm-6">
                        <div
                          className="popout-image"
                          onClick={this.handlePopoutImages}
                        >
                          <img
                            src={`${process.env.PUBLIC_URL}/images/liberty-bonds-2-lg.jpg`}
                            alt=""
                          />
                        </div>
                      </div>
                    </div>
                    <figcaption className="pt-3">
                      Letters are accurately reproduced as historically written
                    </figcaption>
                  </figure>
                </div>
              </div>
              <div className="row">
                <div className="col-md-8">
                  <div className="spacer"></div>
                  <h3>Depression Forces a Reorganization</h3>
                  <p>
                    Like countless American citizens and businesses,
                    Peapack-Gladstone Trust Company was facing its own set of
                    challenges. By the end of its first decade, the
                    institution’s investments in traditionally solid
                    stocks—including International Power and Paper, Chase
                    National Bank, and DuPont Nemours, as well as municipal
                    bonds such as City of Miami—had experienced overwhelming
                    losses. To keep the Bank alive, the Directors made personal
                    sacrifices. The Board discontinued paying each Director $5
                    per meeting, a practice initiated in 1927 when business had
                    been strong. More importantly, the Directors agreed to pool
                    their personal resources and purchase the Bank’s worthless
                    securities for their face value of $73,984. This made it
                    possible for the Bank to remain open while many other area
                    banks failed. Years later, Chairman of the Board T. Leonard
                    Hill said, “The Directors put their money where their mouth
                    was; the Bank was saved and went on to be successful.”
                  </p>
                  <p>
                    As a result of lower capital requirements, the Bank
                    reorganized as a state-chartered bank. With shareholder
                    consent, Peapack-Gladstone Bank was formed on December 30,
                    1931. The next day, the New Jersey Department of Banking and
                    Insurance executed a Certificate of Authority, which
                    permitted the newly organized Peapack-Gladstone Bank to
                    conduct business. The Bank received its Charter from the
                    State later that month.
                  </p>
                  <p>
                    When the Bank’s second President, Francis K. Stevens, was
                    elected shortly after the death of Ellis Tiger in 1934, the
                    office of Chairman of the Board was established. Director
                    George R. Layton was elected to the position. Several months
                    later, the position of “Judges” for elections of the Annual
                    Shareholders’ Meeting was created and filled by T. Leonard
                    Hill and William Rinehart.
                  </p>
                  <p>
                    By summer 1935, the Bank had weathered its first storm.
                    Directors voted to offer stockholders a 2% dividend and to,
                    once again, pay themselves $5 for all regular and special
                    meetings attended (in 1938 the payment was reduced to a
                    token $1 per year). The following year, a pension plan was
                    offered to employees, and safe deposit boxes were made
                    available to customers. As the Bank’s third decade
                    approached, a “return to normalcy” was on the horizon.
                  </p>
                </div>
                <div className="col-md-4">
                  <div className="row">
                    <div className="col-md-12 col-sm-6 mb-md-4 mb-sm-0 mb-4">
                      <figure className="img">
                        <div
                          className="popout-image"
                          onClick={this.handlePopoutImages}
                        >
                          <img
                            src={`${process.env.PUBLIC_URL}/images/charter-hearing.jpg`}
                            alt=""
                          />
                        </div>
                        <figcaption className="text-left">
                          State of New Jersey Notice to appear for a Charter
                          hearing on January 12, 1932 (Peapack-Gladstone Bank
                          archives)
                        </figcaption>
                      </figure>
                    </div>
                    <div className="col-md-12 col-sm-6">
                      <figure className="img">
                        <div
                          className="popout-image"
                          onClick={this.handlePopoutImages}
                        >
                          <img
                            src={`${process.env.PUBLIC_URL}/images/bank-assets.jpg`}
                            alt=""
                          />
                        </div>
                        <figcaption className="text-left">
                          The Bank’s 1939 Statement of Condition, the first year
                          the Bank’s assets exceeded $1 million.
                          (Peapack-Gladstone Bank archives)
                        </figcaption>
                      </figure>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer togglePopout={this.handleTogglePopout} />
        </div>
      </div>
    );
  }
}

export default withRouter(Chapter4);
